// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3lilP","left":"InfoRow_left__2A53r"};